<template>
    <div id="wrap" class="skpfull_wrap">
        <div class="rd_box register">

            <div class="container register">
				<div class="title">
					<h1>{{$t('TITLE.EUR.MY.USER.INFO')}}</h1>
				</div>
				<div class="content">
					<div class="user_info">

                        <table class="view_table noLine">
                            <colgroup>
                                <col width="270px">
                                <col class="*">
                            </colgroup>
                            <tbody>                                 
                                <tr>
                                    <th>{{$t('FIELD.EUR.YOUR.COUNTRY')}} / {{$t('FIELD.GLOBAL.LANGUAGE')}}</th>
                                    <td>{{countryNm}} / {{langNm}}</td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.GLOBAL.ID')}}({{$t('FIELD.GLOBAL.EMAIL')}})</th>
                                    <td>{{email}}</td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.PROFILE.COMPANY.NAME')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" ref="compNm" v-model="companyNm" maxlength="50" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{companyNm}}</span>
                                    </td>                                    
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.COMPANY.REGISTRATION.NUMBER')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" ref="compNo" v-model="companyNo" maxlength="30" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{companyNo}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.EUR.COMP.ADDR')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="address" maxlength="90" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{address}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.POSTAL.CODE')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="zipCd" maxlength="10" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{zipCd}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.COMPANY.WEBSITE.ADDRESS')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="homeUrl" maxlength="40" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{homeUrl}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.EUR.FIRST.NAME')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="contactFrstNm" maxlength="20" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{contactFrstNm}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.EUR.LAST.NAME')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="contactLastNm" maxlength="20" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{contactLastNm}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.CONTACT.PHONE.NUMBER')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="contactPhoneNo" maxlength="20" @keyup="onlyNumber2($event)" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{contactPhoneNo}}</span>
                                    </td>
                                </tr>
                                <tr v-if="countryCd == 'FR' || apeCodes">
                                    <th>{{$t('FIELD.EUR.APE.CODES')}}</th>
                                    <td>
                                        <span v-if="mode == 'edit'" class="clearable">
                                            <input type="text" class="text_input w100" v-model="apeCodes" maxlength="99" v-clearable />
                                        </span>
                                        <span v-if="mode == 'view'">{{apeCodes}}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{$t('FIELD.INSURANCE.POLICY')}}</th>
                                    <td>
                                        <div class="one-input-container modify file-input">
                                            <div v-if="mode == 'edit'" class="upload-btn_wrap">
                                                <button type="button" title="Find file"><span>{{$t('BUTTON.EUR.BROWSER')}}</span></button>
                                                <input type="file" id="file1" class="input_file" title="Find file" @change="fileUpload($event, 1)">
                                            </div>
                                            <input v-if="mode == 'edit'" type="text" v-model="attachFile1Name" class="upload_text" readonly="readonly" autocomplete="off">
                                            <div v-if="mode == 'view' && attachFile1Name">
                                                <a href="JavaScript:" @click="downloadFile('1')"><span>{{attachFile1Name}} ({{fileMb1 | numberFormat}}KB)</span></a>
                                            </div>
                                        </div>
                                    </td>
                               </tr>
                               <tr>
                                    <th>{{$t('FIELD.COMPANY.REGISTRATION.FILE')}}</th>
                                    <td>
                                        <div class="one-input-container modify file-input">
                                            <div v-if="mode == 'edit'" class="upload-btn_wrap">
                                                <button type="button" title="Find file"><span>{{$t('BUTTON.EUR.BROWSER')}}</span></button>
                                                <input type="file" id="file2" class="input_file" title="Find file" @change="fileUpload($event, 2)">
                                            </div>
                                            <input v-if="mode == 'edit'" type="text" v-model="attachFile2Name" class="upload_text" readonly="readonly" autocomplete="off">
                                            <div v-if="mode == 'view' && attachFile2Name">
                                                <a href="JavaScript:" @click="downloadFile('2')"><span>{{attachFile2Name}} ({{fileMb2 | numberFormat}}KB)</span></a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="one-btn-wrap">
                            <button class="bt-type-b" @click="goBackList">{{$t('BUTTON.GLOBAL.CANCEL')}}</button>
                            <button class="bt-type-b next" @click="saveMyInfo">{{btnText}}</button>
                        </div>

					</div>
				</div>
			</div>
        </div>
    </div>
</template>

<script>

import Vue              from 'vue';
import { SDLUtil }      from '@/utils';
import { mapGetters }   from 'vuex';
import qs               from 'query-string';
import axios            from 'axios';
import store            from '@/vuex/store';
import { EventBus }     from '@/utils/EventBus';

export default {
    name: 'EurJoinUserStep2',
    computed: {
        ...mapGetters({
            guid      : 'getGuid',    // GUID
            email     : 'getEmail',
            countryCd : 'getCountryCd',
            countryNm : 'getCountryNm',
            loginId   : 'getLoginId', // bpNo
            langCd    : 'getLangCd',
        })
    },
    data() {
        return {
            win: {},
            mode : 'view',
            btnText: SDLUtil.getMsgProp('FIELD.ADMIN.EDIT'),
            langNm: '',
//            countryNm : '',
            countryLangNm : '',
            langNm : '',
            corpNo: '',
            companyNm: '',
            companyNo: '',
            zipCd: '',
            address: '',
            homeUrl: '',
            contactFrstNm: '',
            contactLastNm: '',
            contactPhoneNo: '',
            apeCodes: '',
            attachFile1Name: '', // Insurance Cetificate Name
            attachFile1Size: '', // Insurance Cetificate Size
            attachFile2Name: '', // Company Regist License Name
            attachFile2Size: '', // Company Regist License Size
            chgFile1Name: '',
            chgFile2Name: '',
            fileMb1: '',
            fileMb2: ''
        };
    },
    methods: {
        loadMyUserInfo() {
            SDLUtil.showLoadingBar(true);
            const params = {guid: this.guid, bpNo: this.loginId, countryCd: this.countryCd};
            const url = `${SDLUtil.API_URL}/noauth/eur/getMyUserInfo.skp`;
            axios.post(url, qs.stringify(params))
                 .then(resp => {
                    console.log('Info.resp ===> ', resp);
                    const userInfo = resp.data;
                    this.corpNo          = userInfo.company;
                    this.companyNm       = userInfo.companyName;
                    this.companyNo       = userInfo.companyRegNo;
                    this.address         = userInfo.companyAddress;
                    this.zipCd           = userInfo.zipCode;
                    this.homeUrl         = userInfo.companyWebAddress;
                    this.contactFrstNm   = userInfo.contactFirstName;
                    this.contactLastNm   = userInfo.contactLastName;
                    this.contactPhoneNo  = userInfo.phoneNumber;
                    this.apeCodes        = userInfo.apeCodes;
                    this.attachFile1Name = userInfo.fileName1; 
                    this.attachFile2Name = userInfo.fileName2; 
                    this.attachFile1Size = userInfo.fileLength1; 
                    this.attachFile2Size = userInfo.fileLength2; 
                    this.fileMb1 = SDLUtil.cutComma(this.attachFile1Size / 1000);
                    this.fileMb2 = SDLUtil.cutComma(this.attachFile2Size / 1000);
                    console.log('this.fileMb1 ==> ', this.fileMb1);
                    console.log('this.fileMb2 ==> ', this.fileMb2);

                    $('#attachFile1').val(userInfo.fileName1);
                    $('#attachFile2').val(userInfo.fileName2);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                }
            );
        },
        // validation
        userValidateion() {
            let bRes = true;

            let valids  = [this.companyNm, this.companyNo, this.address, this.zipCd
                         , this.contactFrstNm, this.contactLastNm, this.contactPhoneNo];
            let fieldNm = ['Company Name', 'Company Registration Number', 'Company Address', 'Postal Code'
                         , 'Contact First Name', 'Contact Last Name', 'Contact Phone Number'];
            $.each(valids, function(idx, elm) {
                if (!elm) {
                    SDLUtil.alert('Empty value at [' + fieldNm[idx] + ']');
                    bRes = false;
                    return false;
                }
            });
            let fileTotalSize = (Number(this.attachFile1Size) + Number(this.attachFile2Size)) / 1000;
            if (fileTotalSize > 10000) {
                SDLUtil.alert('MESSAGE.EUR.FILE.LESS.10MB');
                bRes = false;
            }

            let fileName1 = this.chgFile1Name || this.attachFile1Name;
            let fileName2 = this.chgFile2Name || this.attachFile2Name;
            if (fileName1 == fileName2) {
                SDLUtil.alert('MESSAGE.EUR.DUP.FILE.NAME');
                bRes = false;
            }
            return bRes;
        },
        saveExec(params) {
            SDLUtil.showLoadingBar(true);
            const url = `${SDLUtil.API_URL}/noauth/eur/updateMyUserInfo.skp`;
            axios.post(url, qs.stringify(params), {
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(resp => {
                    console.log('save.resp ===> ', resp);
                    SDLUtil.showLoadingBar(false);
                    if (resp.data.resCode == 'S') { // Success
                        Vue.toasted.show(
                            SDLUtil.getMsgProp('MESSAGE.SUCCESS.SAVED'), {
                                theme: "toasted-primary",
                                position: "top-center",
                                duration : 3000
                            }
                        );
                        this.mode = 'view';
                        this.btnText = SDLUtil.getMsgProp('FIELD.ADMIN.EDIT');
                    } else if (resp.data.resCode == 'F') { // RFC Error
                        SDLUtil.alert(resp.data.resMsg);
                    } else {  // Other Error
                        SDLUtil.alert('MESSAGE.DATA.UPDATE.AUTHERROR');
                    }
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
        },
        saveMyInfo() {

            if (this.mode == 'view') {
                this.mode = 'edit';
                this.btnText = SDLUtil.getMsgProp('BUTTON.GLOBAL.SAVE');
//              this.$refs.compNm.focus();
                return true;
            }

            if (!this.userValidateion()) {
                return;
            }
            // SDLUtil.alert({ msg: 'sdp.currency.exchRate.gdatu' });
  
            let params = {
                guid            : this.guid,
                bpNo            : this.loginId,
                countryCd       : this.countryCd,
                userEmail       : this.email,
                companyNo       : this.companyNo,
                companyNm       : this.companyNm,
                address         : this.address,
                zipCd           : this.zipCd,
                homeUrl         : this.homeUrl,
                contactFrstNm   : this.contactFrstNm,
                contactLastNm   : this.contactLastNm,
                contactPhoneNo  : this.contactPhoneNo,
                apeCodes        : this.apeCodes,
                attachFile1Name : this.chgFile1Name,
                attachFile1Size : this.attachFile1Size,
                attachFile2Name : this.chgFile2Name,
                attachFile2Size : this.attachFile2Size
            };
            console.log('params ===> ', params);

            SDLUtil.confirm({
                msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                title: 'BUTTON.GLOBAL.SAVE',
                onOkEvt: () => {
                    this.saveExec(params);
                },
            });
        },
        onlyNumber(e) { 
            SDLUtil.onlyNumber(e); 
        },
        onlyNumber2(e) { 
            SDLUtil.onlyNumber2(e);
        },
        attachFileClear() {
            let fNames = '';
            if (this.attachFile1Name) fNames = this.attachFile1Name;
            if (this.attachFile2Name) {
                if (fNames.length > 0) fNames += ',' + this.attachFile2Name;
                else                   fNames = this.attachFile2Name;
            }
            let params = { fileNames: fNames };
            axios.post(`${SDLUtil.API_URL}/noauth/eur/clearAttachFiles.skp`, 
                 qs.stringify(params))
                .then(resp => {
                    console.log('clearFiles.resp ===> ', resp);
                })
                .catch(err => {
                    SDLUtil.errorAlert(err);
            });
        },
        goBackList() {
            if (this.mode == 'view') {
                // clearAttachFiles
                this.attachFileClear();
                EventBus.$emit('goBackMyRepairs', 1);
            } else {
                this.mode = 'view';
                this.btnText = SDLUtil.getMsgProp('FIELD.ADMIN.EDIT');
            }
        },
        // 파일 업로드 (Excel)
        fileUpload(e, seq) {
            let oldFileName, oldFileSize, oldfileMb;
            let bAllow = true;
            let files = e.target.files;
            console.log('files ===> ', files, seq);
            if (files.length) {

                if (!SDLUtil.isPermitUploadFile(files[0].name)) {
                    $('#file' + seq).val('');
                    bAllow = false;
                    return bAllow;
                }
                if (!bAllow) return;

                SDLUtil.showLoadingBar(true);
                let formData = new FormData();
                formData.append('attachFile' + seq, files[0]);
                if (seq == 1) { // Insurance Policy File
                    oldFileName = this.attachFile1Name;
                    oldFileSize = this.attachFile1Size;
                    oldfileMb   = this.fileMb1;
                    this.chgFile1Name    = files[0].name;
                    this.attachFile1Name = files[0].name;
                    this.attachFile1Size = files[0].size;
                    $('#attachFile1').val(this.attachFile1Name);
                    this.fileMb1 = SDLUtil.cutComma(this.attachFile1Size / 1000);
                } else if (seq == 2) { // Companay Regist File
                    oldFileName = this.attachFile2Name;
                    oldFileSize = this.attachFile2Size;
                    oldfileMb   = this.fileMb2;
                    this.chgFile2Name    = files[0].name;
                    this.attachFile2Name = files[0].name;
                    this.attachFile2Size = files[0].size;
                    $('#attachFile2').val(this.attachFile2Name);
                    this.fileMb2 = SDLUtil.cutComma(this.attachFile2Size / 1000);
                }

                console.log('this.chgFile1Name ==> ', this.chgFile1Name);
                console.log('this.chgFile2Name ==> ', this.chgFile2Name);

                axios.post(
                    `${SDLUtil.API_URL}/noauth/eur/fileUpload.skp`,
                    formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }
                ).then(resp => {
                    console.log('fileUpload.resp ===> ', resp);
                    if (resp.data == '-1') {
                        SDLUtil.alert('MESSAGE.EUR.NO.PERMIT.FILE');
                    } else if (resp.data == '-2') {
                        SDLUtil.alert('MESSAGE.EUR.NO.FILE.NAME');
                    }
                    if (resp.data != '1') {
                        $('#file' + seq).val('');
                        if (seq == 1) {
                            this.chgFile1Name    = oldFileName;
                            this.attachFile1Name = oldFileName;
                            this.attachFile1Size = oldFileSize;
                            this.fileMb1         = oldfileMb;
                        } else if (seq == 2) {
                            this.chgFile2Name    = oldFileName;
                            this.attachFile2Name = oldFileName;
                            this.attachFile2Size = oldFileSize;
                            this.fileMb2         = oldfileMb;
                        }
                console.log('this.chgFile1Name(2) ==> ', this.chgFile1Name);
                console.log('this.chgFile2Name(2) ==> ', this.chgFile2Name);
                    }
//                    let selModelList = resp.data.result;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });
            }
        },
        downloadFile(fileType) {
            const url = `${SDLUtil.API_URL}/noauth/eur/getAttachFileInfo.skp`;
            let params = {
                  fileType: fileType
                , guid    : this.guid
                , bpNo    : this.loginId
                , corpNo  : this.corpNo
            };
            axios.post(url, qs.stringify(params))
            .then(resp => {
                console.log('fileDownload.resp.data ===> ', resp.data);
                let filePath = resp.data.fileDownUrl.replace(/\\/g, '/');
                console.log('filePath ===> ', filePath);
                let fName = filePath.split('/').pop();
                let links = document.createElement('a');
                links.href     = filePath;
                links.download = fName; // resp.data.fileDownUrl;
                links.target   = '_blank';
                document.body.appendChild(links);
                links.click();
                document.body.removeChild(links);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });
        }
    },
    created() {
    },
    mounted() {
        console.log('guid ==> ', this.guid);
        console.log('countryCd ==> ', this.countryCd);
        console.log('countryNm ==> ', this.countryNm);
        if (!this.countryNm) {
            this.countryNm = localStorage.getItem('eur.user.country.name');
        }
        console.log('countryNm(2) ==> ', this.countryNm);
        console.log('email ==> ', this.email);
//        this.countryNm = localStorage.getItem('eur.user.country.name'); // loginCountryNm
        this.langNm = localStorage.getItem('eur.user.lang.name');
        this.countryLangNm = this.countryNm + ' / ' + this.langNm;

        if (this.guid && this.countryCd && this.email) {
            this.loadMyUserInfo();
        } else {
            this.$nextTick(() => {
                SDLUtil.alert({
                    msg: 'MESSAGE.SESSION.HAS.EXPIRED',
                    onOkEvt: () => {
                        let pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`;
                        this.$router.push({ path: pathUrl, query: {}});
                    }
                });
            });
        }
    },
    watch: {
        errorState() {
            alert(this.errorState.code);
            this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/error` });
        },
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/basis/eur/user/EditMyUserInfo.vue